module.exports = __webpack_public_path__ + "img/software-thumb-2.e4777402.png";